<template>
  <div>
    <button @click="openModal" class="btn-outline btn-dark"><i class="fa-classic fa-plus"></i>Generate VIBAN</button>
    <alert-modal v-if="isAlertOpen && this.countNewVibans > 0">
      <span><i class="fa-solid fa-circle-check"></i>Successfully generated {{ this.countNewVibans }} VIBANs</span>
    </alert-modal>
    
    <!-- modal generate viban -->
    <div class="modal-container" v-if="isModalOpen">
      <div class="modal-content">
        <h1>Generate VIBANs<i @click="closeModal" class="fa-regular fa-xmark"></i></h1>
        <span>Generate new VIBANs for the pool</span>
  
        <span class="filter-item-title">Quantity</span>
        <input type="number" class="filter-item-content" placeholder="Quantity..." @input="updateQuantity"/>
  
        <!-- Country -->
        <span class="filter-item-title">Country Code</span>
        <div class="filter-item">
          <a id="country-modal-picker-link" 
            class="filter-item-content d-flex justify-content-between py-2 px-3"
            href="#">
            <span class="fixed-span-size">
              {{ generateVibanObj.country == null || generateVibanObj.country == "all" ? 'All Countries' : countryList.filter(item => {
                if(item.code == generateVibanObj.country){
                  return item
                }
            })[0].label}}
            </span>
            <i class="fa-light fa-chevron-down" size="17px" id="action-type-chevron"></i>
          </a>
          <b-popover target="country-modal-picker-link" triggers="focus" placement="bottom" custom-class="popover">
            <div>
              <span v-for="(country, index) in countryList" :key="index" :class="['popover-option', {'popover-option-selected':  country.code == generateVibanObj.country}]" @click="selectCountryModal(country.code)">
                {{ country.label }} {{ country.code != null ? '(' + country.code + ')' : '' }}
              </span>
            </div>
          </b-popover>
        </div>
  
        <div class="modal-content-buttons">
          <button class="btn-outline-light btn" @click="closeModal">Cancel</button>
          <button class="btn-outline btn-dark" @click="generateVIBAN">Generate</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import alertModal from './alertModal.vue'
export default{
  components: { alertModal },
  name: 'GenerateVIBANModal',
  emits: ['update:refresh'],
  data(){
    return{  
      isModalOpen: false,
      countryList: [
        {
          label: "All Countries",
          code: null
        },
        {
          label: "France",
          code: "FR"
        },
        {
          label: "Germany",
          code: "DE"
        },
        {
          label: "Spain",
          code: "ES"
        },
        {
          label: "UK",
          code: "GB"
        },
        {
          label: "Belgium",
          code: "BE"
        },
        {
          label: "Italy",
          code: "IT"
        }
      ],
      generateVibanObj: {
        country : null,
        quantity : null
      },
      isAlertOpen: false,
      countNewVibans: 0
    }
  },
  methods: {
    openModal () {
      this.isModalOpen = true
    },
    closeModal (){
      this.isModalOpen = false
      this.generateVibanObj.country = null
      this.generateVibanObj.quantity = null
    },
    selectCountryModal (code){
      this.generateVibanObj.country = code
    },
    updateQuantity(event) {
      this.generateVibanObj.quantity = event.target.value
    },
    generateVIBAN () {
      const quantity = this.generateVibanObj.quantity;
      const country  = this.generateVibanObj.country;

      if(country == null || quantity == null || quantity <= 0 ) return

      const requests = Array.from({ length: quantity }, () =>
        this.$engine.services.payments.createVIBAN({ country })
      );

      this.countNewVibans = quantity

      Promise.all(requests)
        .then(responses => {
          this.closeModal()
          this.isAlertOpen = true;
          setTimeout(()=>{
            this.isAlertOpen = false;
            this.countNewVibans = 0
          }, 3000)
          this.$emit('update:refresh')
        })
        .catch(err => console.log(err));
    }
  }
}
</script>
<style>

.modal-container{
  width: 100vw; 
  height: 100vh; 
  position: fixed; 
  background-color: rgba(0, 0, 0, 0.5); 
  z-index: 5000; 
  overflow: hidden; 
  top: 0; 
  left: 0; 
  display: flex; 
  justify-content: center; 
  align-items: center;
}

.modal-content .filter-item {
  margin: 1rem 0rem;
}

.modal-content>h1{
  font-weight: bold;
  font-size: 1.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
}

.modal-content>h1>i{
  cursor: pointer;
}

.modal-content>input{
  margin-bottom: 1.5rem;
}

.modal-content>span:first-of-type{
  color: #717182;
  margin-bottom: 1rem;
}

.modal-content>span:last-of-type{
  color: #000;
  font-weight: bold;
}

.modal-content-buttons{
  display: flex;
  justify-content: end;
  gap: 1rem;
  align-items: center;
}
</style>
